import Chip, { ChipProps } from '@mui/material/Chip';
import type { SxProps, Theme } from '@mui/material/styles';

import { mergeSx } from '@/utils/mergeSx';

import { chipsStyles as sx } from './Chips.styles';

export type BasicChipVariant =
	'basic' | 'primary' | 'secondary' | 'removed' | 'success';

const VARIANT_STYLES: Record<BasicChipVariant, SxProps<Theme>> = {
	basic: sx.basicChip,
	primary: sx.primaryChip,
	secondary: sx.secondaryChip,
	removed: sx.removedChip,
	success: sx.successChip
};

type Props = Omit<ChipProps, 'variant'> & {
	label: string;
	variant?: BasicChipVariant;
	customSx?: SxProps<Theme>;
};

export const BasicChip = ({
	label,
	variant = 'basic',
	customSx,
	...rest
}: Props) => (
	<Chip
		label={label}
		size='small'
		sx={mergeSx(
			variant !== 'removed' && sx.chipRoot,
			VARIANT_STYLES[variant],
			customSx
		)}
		{...rest}
	/>
);
